import { render, staticRenderFns } from "./NavigationItem.vue?vue&type=template&id=1f919667&"
import script from "./NavigationItem.vue?vue&type=script&lang=js&"
export * from "./NavigationItem.vue?vue&type=script&lang=js&"
import style0 from "./NavigationItem.vue?vue&type=style&index=0&id=1f919667&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports